import getTag from './internals/getTag.js';
import { stringTag } from './internals/native.js';

function isString(value) {
    return typeof value === 'string' || getTag(value) === stringTag;
}

export { isString as default };
